const getCookie = (name: string): string | null => {
  const cookie = ("; " + document.cookie).split("; " + name + "=");
  return cookie.length >= 2 ? cookie.pop()!.split(";")!.shift()! : null;
};

export type CookieOptions = {
  domain?: string;
  path: string;
  expires: number;
};

const constructCookieDomain = (domain?: string): string => {
  // If a domain string is set, and it's not an empty string,
  // create the domain param for the cookie, otherwise return empty string.
  return domain?.length ? ` domain=${domain};` : "";
};

const setCookie = (
  name: string,
  value: string,
  options: CookieOptions,
): void => {
  const expireDate = new Date();
  expireDate.setTime(expireDate.getTime() + options.expires * 1000);
  document.cookie = `${name}=${value};${constructCookieDomain(options.domain)} path=${options.path}; expires=${expireDate.toUTCString()}`;
};

const deleteCookie = (
  name: string,
  options: Omit<CookieOptions, "expires">,
): void => {
  document.cookie = `${name}=;${constructCookieDomain(options.domain)} path=${options.path}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};

export type CookieManager = {
  set: (name: string, value: string, options: CookieOptions) => void;
  get: (name: string) => string | null;
  delete: (name: string, options: Omit<CookieOptions, "expires">) => void;
};

export const cookieManager: CookieManager = {
  set: setCookie,
  get: getCookie,
  delete: deleteCookie,
};
